export const BLOG_TISSUE_URL = '/blog/divannye-tkani-plyusy-i-minusy';
